import { bus } from "@/init/_bus";

export default class EventService {
  public listen(event: string, callback: (...args: any[]) => void): void {
    bus.$on(event, callback);
  }
}
